<template>
  <div class="adv">
    <img src="./resources/adv_img.jpeg" alt="adv" srcset />
  </div>
</template>

<script>
import { _isMobile } from '@/utils/config';

export default {
  name: 'adv',
  // 与父组件通信
  props: {},
  components: {},
  // 数据
  data() {
    return {
      bodyWidth: 0,
      isMobile: _isMobile(),
    };
  },
};
</script>
<style scoped lang="less">
@import './index.less';
</style>
